/**
 * Partner/university theme (`theme-config:{host}`) may set `showRateAndReviews: false`.
 * Hosts without that flag keep the default (show the top profile rate box).
 */
export const shouldShowProfileHeadRateBox = (showRateAndReviews?: boolean) =>
  showRateAndReviews !== false;
